import type { GenerationMetrics, ReviewRequiredReason } from '@realplc/types';

export type DeliveryReview = NonNullable<GenerationMetrics['reviewRequired']>;
export type DeliveryLabelLanguage = string | ((key: string) => string);

const REASONS = new Set<ReviewRequiredReason>([
  'not_judged', 'l5a_not_run', 'l5a_no_verdict', 'l5a_partial_pass',
]);

/** Read the explicit worker mark, or the registry's older array of reasons. Never infer a mark on old records. */
export function readDeliveryReview(value: unknown): DeliveryReview | undefined {
  const record = value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown> : undefined;
  const reasons = Array.isArray(value) ? value : record?.reasons;
  if (!Array.isArray(reasons) || !reasons.every(reason => REASONS.has(reason as ReviewRequiredReason))) return undefined;
  if (record && typeof record.required !== 'boolean') return undefined;
  return { required: record ? record.required as boolean : reasons.length > 0, reasons: [...reasons] as ReviewRequiredReason[] };
}

/** Every label of a delivered program's passing checks uses the same explicit review decision. */
export function deliveryValidationLabel(passedLabel: string, review: unknown, language?: DeliveryLabelLanguage): string {
  if (!readDeliveryReview(review)?.required) return passedLabel;
  if (typeof language === 'function') return language('Review required');
  return language === 'English' || language === 'en' ? 'Review required' : '需复核';
}
